var _style, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyDocuments(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 89 89",
    style: {
      enableBackground: "new 0 0 89 89"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#FFCC33;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M64.6,71.5c-13.5,0-27.1,0-40.6,0c-1.5-0.5-2.3-1.4-2.6-3c-0.7-4.7-1.4-9.3-2.2-14c-0.5-3.4-1.1-6.9-1.6-10.3 c-0.2-1.2,0.6-2.4,1.8-2.6c0.2-0.1,0.5-0.1,0.7-0.1c-0.1-0.6-0.2-1.1-0.3-1.6c-0.4-2.3,0.9-3.8,3.2-3.8c3.8,0,7.7,0,11.5,0 c1.5,0,2.6,0.5,3.5,1.6c1,1.2,2,2.3,3,3.5c0.2,0.2,0.5,0.3,0.7,0.3c0.5,0.1,0.9,0,1.4,0c5.6,0,11.2,0,16.8,0c1.5,0,2.4,0.7,2.6,2 c0.4,2.4,0.7,4.8,1.1,7.2c0.7,4.4,1.3,8.8,2,13.2c0.2,1.6,0.5,3.3,0.7,5c0.1,1.1-0.5,2-1.5,2.4C64.8,71.4,64.7,71.5,64.6,71.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62.5,38.6c-1.2,0-2.4,0-3.6,0c0-5.8,0-11.6,0-17.4c-8.6,0-17.2,0-25.8,0c0,4.1,0,8.2,0,12.4 c-1.3,0-2.6,0-3.9,0c0-0.2,0-0.4,0-0.6c0-4.2,0-8.4,0-12.5c0-1.9,0.9-2.9,2.9-2.9c9.2,0,18.4,0,27.6,0c1.9,0,2.7,0.9,2.7,2.7 c0,5.9,0,11.8,0,17.7C62.5,38.1,62.5,38.3,62.5,38.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M68.1,61.8c-1.2-7.9-2.6-15.8-3.2-23.9c0.9,0,1.9,0,2.8,0c0.4,0,0.9,0,1.3,0c1.4,0,2.4,1.2,2.2,2.6 c-0.4,3.1-0.9,6.3-1.4,9.4c-0.6,3.8-1.1,7.5-1.7,11.3C68.2,61.3,68.2,61.6,68.1,61.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.9,25.1c2.4,0,4.9,0,7.3,0c0.9,0,1.5,0.5,1.8,1.3c0.3,0.8,0,1.6-0.7,2.1c-0.3,0.2-0.8,0.4-1.2,0.4 c-4.9,0-9.8,0-14.7,0c-1.1,0-1.9-0.9-1.9-1.9c0-1.1,0.8-1.9,1.9-1.9C41,25,43.5,25.1,45.9,25.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.8,33.8c0.2-1,0.9-1.6,1.9-1.6c2,0,3.9,0,5.9,0c2.8,0,5.7,0,8.5,0c0.8,0,1.5,0.4,1.8,1.1 c0.3,0.7,0.2,1.4-0.2,2c-0.4,0.5-0.9,0.7-1.5,0.7c-4.2,0-8.4,0-12.6,0c-0.1,0-0.3,0-0.4-0.1C39.3,34.9,38.2,34.1,36.8,33.8z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyDocuments);
export default __webpack_public_path__ + "static/media/my-documents.a8652eb5fdf62cd00f62e5badff7f33f.svg";
export { ForwardRef as ReactComponent };